import { useContext } from 'react'
import { ClientColorsContext } from '../../contexts/data/ClientColors.context'

const useClientColorsContext = () => {
  const data = useContext(ClientColorsContext)
  return data
}

export default useClientColorsContext
